import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { observer } from 'mobx-react';
import React from 'react';

import { usePlpStore } from 'components/modules/plp/DataStore';
import useOwnRouter from 'lib/hooks/useOwnRouter';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { useUrlFactory } from 'lib/hooks/useUrlFactory';

function Pagination() {
  const { t } = useOwnTranslate('plp.pagination');
  const {
    page: pageNumber,
    setPage: setPageNumber,
    isValidToNext,
  } = usePlpStore();
  const urlFactory = useUrlFactory();
  const router = useOwnRouter();

  const changePage = (changeType: 'next' | 'prev' = 'next') => {
    const page = changeType === 'next' ? pageNumber + 1 : pageNumber - 1;
    setPageNumber(page);
    urlFactory.modify('page', page.toString());
    router.push(`/${urlFactory.fullPathname}`, '', { shallow: true });
    setTimeout(() => {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
      console.log('to top');
    }, 1000);
  };

  return (
    <nav
      aria-label="Page navigation"
      className="flex items-center justify-center"
    >
      <ul className="inline-flex items-center justify-center h-10 mb-2 -space-x-px rtl:space-x-reverse ">
        {pageNumber !== 0 && (
          <li>
            <button
              className="flex items-center justify-between px-3 py-2 leading-tight bg-white border border-r-0 rounded-l-md text-grey-500 border-grey-300 hover:bg-grey-100 hover:text-grey-700 rtl:flex-row-reverse rtl:border-l-0 rtl:border-r rtl:rounded-r-md rtl:rounded-l-none"
              onClick={() => changePage('prev')}
            >
              {t('prev')}
              <ChevronLeftIcon className="w-4 h-4 rtl:rotate-180" />
            </button>
          </li>
        )}
        <li>
          <button className="flex items-center justify-center px-3 py-2 leading-tight bg-white border text-grey-500 border-grey-300 hover:bg-grey-100 hover:text-grey-700">
            {pageNumber + 1}
          </button>
        </li>
        <li>
          <button
            className="flex items-center justify-between px-3 py-2 leading-tight bg-white border border-l-0 rounded-r-md text-grey-500 border-grey-300 hover:bg-grey-100 hover:text-grey-700 rtl:flex-row-reverse rtl:border-r-0 rtl:border-l rtl:rounded-l-md rtl:rounded-r-none disabled:cursor-not-allowed disabled:text-grey-300"
            disabled={!isValidToNext}
            onClick={() => isValidToNext && changePage()}
          >
            <ChevronRightIcon className="w-4 h-4 rtl:rotate-180" />
            {t('next')}
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default React.memo(observer(Pagination));
